import { createSelector } from 'reselect';
import { RouterState } from 'redux-first-history';

import { getParam } from 'utils/urlParams';

export const selectRouterLocation = (state: { router: RouterState }) =>
  state.router?.location || { pathname: '', search: '' };

export type EnabledPreview = string;

export const selectEnabledPreviews = createSelector(
  selectRouterLocation,
  ({ pathname = '', search = '' }): EnabledPreview[] => {
    // in order to get the URL params, we need to construct the URL sans origin
    const enabledPreviews = getParam(`${pathname}${search}`, 'previews') || '';
    return enabledPreviews.split(',').filter((v) => !!v); // trim out any falsy values
  },
);
